// extracted by mini-css-extract-plugin
export default {"checkbox-row":"Form_checkbox-row__1N32y","form":"Form_form__VDwG8","form-error":"Form_form-error__avHMb","save":"Form_save__oukof","form-submit":"Form_form-submit__phCd7"};